import { useVariant } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { Button } from '@calendly/ui/components/button';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import bannerImage from './images/banner_image_payments.png';
import { useGetUserQuery, useUpdateUserGrowthExperimentsMutation } from '../../../common';
import { TRACKING_EVENT_NAMES, useTrack, useTrackOnce } from '../../../hooks/analytics_events';
import { hasOnboardingPaymentsFlag, isOnboardingPaymentsBannerVariant, ONBOARDING_PAYMENTS_EXPERIMENT_KEY } from '../../../hooks/growth_experiments/use-onboarding-payments-experiment';
const styledBannerCss = "s1w175xn";
const StyledBanner = forwardRef((props, ref) => <Banner ref={ref} {...props} className={classNames(styledBannerCss, props.className)} />);
StyledBanner.displayName = 'StyledBanner';
const contentIsTabletDownCss = "cdy7x62";
const contentCss = "c11jpfbv";
const illustrationSpacerCss = "i1jok0q2";
const illustrationIsTabletDownCss = "ilmfvo0";
const illustrationCss = "i1o6rez4";
const textStackCss = "tabaf9n";
const titleCss = "t1h6mekt";
const descriptionCss = "d12occ6e";
const ctaButtonCss = "c1b530h6";
const BANNER_DISMISSED_KEY = 'event_type_banner_dismissed';
const OnboardingPaymentsBannerContent = () => {
  const variant = useVariant(ONBOARDING_PAYMENTS_EXPERIMENT_KEY);
  const shouldShow = isOnboardingPaymentsBannerVariant(variant);
  const {
    data: userData
  } = useGetUserQuery();
  const [updateGrowthExperiments] = useUpdateUserGrowthExperimentsMutation();
  const track = useTrack();
  const [isDismissed, setIsDismissed] = useState(false);
  const isTabletDown = useDeviceType('isTabletDown');
  const existingExperimentState = userData?.growth_experiments?.[ONBOARDING_PAYMENTS_EXPERIMENT_KEY] || {};
  const isBannerDismissed = Boolean(existingExperimentState[BANNER_DISMISSED_KEY]);
  const hasUser = Boolean(userData?.uuid || userData?.id);
  const dismissalPayload = {
    [ONBOARDING_PAYMENTS_EXPERIMENT_KEY]: {
      ...existingExperimentState,
      [BANNER_DISMISSED_KEY]: true
    }
  };
  useTrackOnce(hasUser && shouldShow && !isDismissed && !isBannerDismissed, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    properties: {
      cta_key: 'scheduling_page',
      cta_text: 'get_paid_before_client_meetings'
    }
  });
  const handleClose = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'dismissed',
        cta_key: 'scheduling_page',
        cta_text: 'get_paid_before_client_meetings'
      }
    });
    setIsDismissed(true);
    updateGrowthExperiments(dismissalPayload);
  };

  // Don't show until user data is loaded to prevent mutation failures
  if (!hasUser || !shouldShow || isDismissed || isBannerDismissed) {
    return null;
  }
  return <StyledBanner onClose={handleClose}>
      <div className={classNames(contentCss, {
      [contentIsTabletDownCss]: isTabletDown
    })}>
        <div className={illustrationSpacerCss} aria-hidden="true">
          <img src={bannerImage} alt="" className={classNames(illustrationCss, {
          [illustrationIsTabletDownCss]: isTabletDown
        })} />
        </div>
        <div className={textStackCss}>
          <TitleText level="4" className={titleCss}>
            {I18n.t('publisher.growth_experiments.onboarding_payments.banner_title')}
          </TitleText>
          <BodyText size="medium" className={descriptionCss}>
            {I18n.t('publisher.growth_experiments.onboarding_payments.banner_description')}
          </BodyText>
          <Button as="a" href="/integrations?category=payments" decoration="primary" className={ctaButtonCss} onClick={() => track({
          name: TRACKING_EVENT_NAMES.CTA_CLICKED,
          properties: {
            action: 'interaction',
            cta_key: 'scheduling_page',
            cta_text: 'get_paid_before_client_meetings'
          }
        })}>
            View integrations
          </Button>
        </div>
      </div>
    </StyledBanner>;
};
export const OnboardingPaymentsBanner = () => hasOnboardingPaymentsFlag() ? <OnboardingPaymentsBannerContent /> : null;

require("./onboarding_payments_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./onboarding_payments_banner.js");